import AppConstants from "../config/app.constants";

let ItemTypeService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/item-type`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };


    let create = (data) => {
        return $http
            .post(AppConstants.api + `/item-type/create`, data)
            .then((res) => {
                return res.data
            })
    }


    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/item-type/${id}/update`, { data })
            .then((res) => {
                return res.data;
            })
    };

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/item-type/${id}`)
            .then((res) => {
                return res.data;
            })
    }

    return {
        create,
        all,
        update,
        get
    }
}

ItemTypeService.$inject = ['$http', '$q']

export default ItemTypeService;


// WEBPACK FOOTER //
// ./client/app/services/item-type.service.js